import React from 'react';
import { LinearProgress, Box, Typography } from '@mui/material';

const LinearProgressIndicator = ({
  value = 0,
  variant = "determinate", // determinate, indeterminate, buffer, query
  color = "primary",
  showLabel = false,
  label,
  height = 4,
  sx = {}
}) => {
  const getLabel = () => {
    if (label) return label;
    if (showLabel && variant === "determinate") {
      return `${Math.round(value)}%`;
    }
    return null;
  };

  return (
    <Box sx={{ width: '100%', ...sx }}>
      {getLabel() && (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <Typography variant="body2" color="text.secondary">
            {getLabel()}
          </Typography>
        </Box>
      )}
      <LinearProgress
        variant={variant}
        value={value}
        color={color}
        sx={{
          height,
          borderRadius: height / 2,
          backgroundColor: 'grey.200',
          '& .MuiLinearProgress-bar': {
            borderRadius: height / 2,
          }
        }}
      />
    </Box>
  );
};

export default LinearProgressIndicator;
